import type { DocumentLineView } from "@/lib/proforma.api";

export function formatMoney(value: string | number): string {
  const amount = typeof value === "number" ? value : parseFloat(value);
  return `${amount.toLocaleString("fr-FR")} XAF`;
}

export function formatDate(value?: string): string {
  return value ? new Date(value).toLocaleDateString("fr-FR") : "-";
}

export function formatDateTime(value?: string): string {
  return value ? new Date(value).toLocaleString("fr-FR") : "-";
}

export function formatProformaAge(value: string): string {
  const created = new Date(value).getTime();
  const diffDays = Math.max(0, Math.floor((Date.now() - created) / 86_400_000));
  if (diffDays === 0) return "Aujourd'hui";
  if (diffDays === 1) return "Hier";
  return `Il y a ${diffDays} jours`;
}

export function getLineTypeLabel(type: DocumentLineView["lineType"]): string {
  if (type === "ticket") return "Billet";
  if (type === "shop") return "PrestiShop";
  return type;
}
